let slickDefaults = require('./../slick-default/slick-default');
let size = require('./../../modules/size');
import Events from '../tracker/events';
const event = new Events();

jQuery(function($) {
    $('body').on('click', '.js-show-popup-card', function(e) {
        e.preventDefault();
        $.ajax({
            url:
                '/ajax/component/maximaster:catalog.element/popup/?POPUP=Y&ELEMENT_CODE=' +
                $(this).data('elem_code') +
                '&NO_BASKET=' +
                $(this).data('no-basket'),
            success: function(result) {
                var cardHtml = result.html;
                $.prompt(cardHtml, {
                    buttons: {},
                    persistent: false, //чтобы можно было закрыть при клике по оверлею
                    classes: {
                        prompt: 'prompt--product',
                        form: 'prompt__form--special',
                        close: 'jqiclose--cross'
                    },
                    statechanged: function() {
                        var $jqi = $('.jqi');
                        var $card = $jqi.find('.product-card');
                        if ($card.length > 0) setProductCard($card);

                        event.onShowProductCardPopup();
                    }
                });
            }
        });
        return false;
    });

    function setProductCard($card) {
        if ($card == undefined) $card = $('.product-card');

        var $cardPreviews = $card.find('.js-slick-previews:visible');
        var $cardPreviewsCompact = $card.find('.js-slick-previews-compact:visible');

        if ($cardPreviews.length > 0) {
            $cardPreviews.slick(
                $.extend({}, slickDefaults.params, {
                    slidesToShow: 4,
                    vertical: false,
                    verticalSwiping: false,
                    responsive: [
                        {
                            breakpoint: size.tabletBig,
                            settings: { slidesToShow: 3 }
                        },
                        {
                            breakpoint: size.tablet,
                            settings: {
                                slidesToShow: 4,
                                vertical: true,
                                verticalSwiping: true
                            }
                        }
                    ]
                })
            );
        }

        if ($cardPreviewsCompact.length > 0) {
            $cardPreviewsCompact.slick(
                $.extend({}, slickDefaults.params, {
                    slidesToShow: 4,
                    vertical: true,
                    verticalSwiping: true,
                    responsive: [
                        {
                            breakpoint: size.desktop,
                            settings: {
                                slidesToShow: 4,
                                vertical: false,
                                verticalSwiping: false
                            }
                        },
                        {
                            breakpoint: size.tabletBig,
                            settings: {
                                slidesToShow: 3,
                                vertical: false,
                                verticalSwiping: false
                            }
                        },
                        {
                            breakpoint: size.tablet,
                            settings: {
                                slidesToShow: 4,
                                vertical: true,
                                verticalSwiping: true
                            }
                        }
                    ]
                })
            );
        }
    }
});



// WEBPACK FOOTER //
// ./blocks/product-card/popup-product-card.js